module.exports = __webpack_public_path__ + "static/media/overpass-thin-italic.2ad7b693.ttf";